module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_EL-7b02b596f7e74e07cb8a97ba7669574c.svg";